import type React from "react"

import { HStack } from "@/nzds/layout"

import type { DataGridLegendItemProps } from "./data-grid-legend-item.types"

export const DataGridLegendItem: React.FC<DataGridLegendItemProps> = ({
  label,
  value,
  ...rest
}) => {
  return (
    <HStack sx={{ alignItems: "center", gap: 1 }} {...rest}>
      {label} <strong>{value}</strong>
    </HStack>
  )
}
